module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm6"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', [_vm._v("My thanks to: Marisa and Jack for their understanding and indulgence; Andrew Torrance and Steve T for their technical insight; and Frightened Rabbit for the soundtrack in my head.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8351de2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 78
// module chunks = 0